import _ from "lodash";
import workletUrl from 'worklet-loader!./deepHearing/2.3/dh-denoise-processor'

export class GrmNoiseCancel {
    #BASE_OPTIONS = {
        // baseServerUrl: '',
        sampleRate: 48000,
        syncTrackLifeCycle: false
    };
     
    #opt = {};
    #init = false;
    #audioCtx;
    #dhWorkletNode;
    #paramDenoiseOn;
    #source;
    #dst;
    #isErrorOccured = false;
    
    constructor() {
        if(!this.isAvailable()){
            console.warn('This browser does not support AudioContext');
        }
    }
    
    isAvailable() {
        if(window.AudioContext || window.webkitAudioContext || this.#isErrorOccured){
            return true;
        }else{
            return false;
        }            
    }
    
    saveOptions(options={}) {
        this.#opt = _.merge({}, this.#BASE_OPTIONS, options);
    }
        
    getOptions(){
        return _.merge({}, this.#opt);
    }

    async init(options={}){
        try{
            if (!this.isAvailable()) {
                console.warn('Could not init.');
                throw new Error('This browser does not support AudioContext');
            }

            if (this.#init) {
                // return Promise.reject('init already');
                return Promise.resolve(this);
            }
            this.#init = true;

            this.saveOptions(options);

            const {
                sampleRate,
                onprocessorerror
            } = this.#opt;

            this.onprocessorerror(onprocessorerror);
            this.#audioCtx = new (window.AudioContext || window.webkitAudioContext)({sampleRate});

            let wUrl = workletUrl;
            // TODO worklet-loader 으로 불러올 경우 오류가 발생. cdn 으로 임시 대체. config 로 뺄 것.
            wUrl = 'https://biz-cdn.gooroomee.com/files/web/common/lib/external/noisecancel/deepHearing/2.3/dh-denoise-processor.js';
            console.log('# load processor :', wUrl)
            await this.#audioCtx.audioWorklet.addModule(wUrl);

            this.#dhWorkletNode = new AudioWorkletNode(this.#audioCtx, "dh-denoise-processor", {
                processorOptions: {
                    sampleRate: this.#audioCtx.sampleRate
                }
            });
            this.#dhWorkletNode.port.postMessage("init")

            this.#paramDenoiseOn = this.#dhWorkletNode.parameters.get('denoise');
            this.#paramDenoiseOn?.setValueAtTime(true, 0);

            this.#dhWorkletNode.onprocessorerror = this.#opt.onprocessorerror

            return new Promise(((resolve, reject) => {
                this.#dhWorkletNode.port.onmessage = res => {
                    if (res.data == 'ready') {
                        this.#audioCtx.resume();
                        resolve('ready')
                    }
                }
            }))
        }catch (e) {
            this.#opt.onprocessorerror(e)
            return Promise.reject(e);
        }
    }
    onprocessorerror(listener){
        this.#opt.onprocessorerror = (e)=>{
            this.#isErrorOccured = true;
            if(listener)
                listener(e)
            else
                console.error(e);
        };
        return this;
    }
    destroy(){
        this.standBy();
        // worklet processor 멈추고, process 내부에서 return false 하도록 해야함
    }
    standBy(){
        this.#dhWorkletNode && this.#dhWorkletNode.disconnect();
        if(this.#dst){
            this.#dst.stream.getAudioTracks()
                .forEach(t => t.stop());
            // delete this.#dst;
        }

        if(this.#source) {
            this.#source.disconnect();
            // delete this.#source;
        }
    }
    isRunning(){
        return this.#paramDenoiseOn.value === 1;
    }
    getStream(){
        return this.stream;
    }
    getDstStream(){
        return this.#dst && this.#dst.stream;
    }
    setStream({stream, stopCurrentTrack=false, activate=true}){
        if(!this.#init){
            console.warn('Unable before initializing');
            return stream;
        }
        
        const currStream = this.getStream();
        if(currStream === stream){
            return stream;
        }

        if(stream.getAudioTracks().length < 1){
            console.warn('audio track is empty');
            return stream;
        }

        if(stopCurrentTrack === true && currStream){
            currStream.getAudioTracks().forEach(t => t.stop());
        }
        this.stream = stream;
        this.standBy();
        
        if(this.#audioCtx.state === 'suspended'){
            this.#audioCtx.resume()
        }

        this.#source = this.#audioCtx.createMediaStreamSource(stream);
        this.#dst = this.#audioCtx.createMediaStreamDestination();
        this.#source.connect(this.#dhWorkletNode)
            .connect(this.#dst);

        if(stream.getVideoTracks().length > 0){
            this.#dst.stream.addTrack(stream.getVideoTracks()[0]);
        }

        this.#dst.stream.getAudioTracks().forEach(t => {
            t._grm_nc = Date.now();
        });

        if(this.getOptions().syncTrackLifeCycle){
            const srcTrack = stream.getAudioTracks()[0];
            const track = this.#dst.stream.getAudioTracks()[0];
            track.addEventListener('_grm_nc_stop', e => {
                this.standBy();
                srcTrack && srcTrack.stop();
            });
            const _ori = track.stop;
            srcTrack.stop = function(){
                if(srcTrack.readyState !== 'live') return;
                _ori.apply(srcTrack);
                track.stop();
            }
            track.stop = function(){
                if(track.readyState !== 'live') return; // 이미 정지된 track이 requestRenegotiation 에 의해 다시 호출될 때, 노이즈 캔슬 리소스 반납 방지
                _ori.apply(track);
                track.dispatchEvent(new Event('_grm_nc_stop'));
            }
        }

        return this.#dst.stream;
    }
    activate(){
        if(!this.#init){
            console.warn('Unable to de/activate noise cancel before initializing');
            return;
        }
        
        if(!this.#dhWorkletNode || this.isRunning()) return;

        this.#paramDenoiseOn.setValueAtTime(true, 0);
        return this;
    }
    deactivate(){
        if(!this.#init){
            console.warn('Unable to de/activate noise cancel before initializing');
            return;
        }
        
        if(!this.#dhWorkletNode || !this.isRunning()) return;

        this.#paramDenoiseOn.setValueAtTime(false, 0);
        return this;
    }
}

export const grmNoiseCancel = new GrmNoiseCancel()
